import React from "react";
import { Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

import "./RefundPolicy.css";


function RefundPolicy() {

    return (
        <>
            <Header />


            {/* =====================================================
                REFUND POLICY HERO / BREADCRUMB
            ===================================================== */}

            <section className="refund-hero">

                <div className="container">

                    <div className="refund-hero-content">

                        <span className="refund-badge">
                            HOMOEOADDA
                        </span>

                        <h1>
                            Refund Policy
                        </h1>

                        <ol className="breadcrumb">

                            <li className="breadcrumb-item">
                                <Link to="/">
                                    Home
                                </Link>
                            </li>

                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                Refund Policy
                            </li>

                        </ol>

                    </div>

                </div>

            </section>


            {/* =====================================================
                REFUND POLICY CONTENT
            ===================================================== */}

            <section className="refund-content-section">

                <div className="container">

                    <div className="refund-content-card">

                        <div className="refund-section">

                            <h2 className="section-heading-center">
                                Refund Policy
                            </h2>

                            <p className="refund-main-text">
                                Any course or product once purchased/subscribed
                                shall only be liable for refund or cancellation
                                under circumstances when mentioned course
                                /product not fulfillgiven terms within 24hours
                                of payment*
                            </p>

                            <p className="refund-terms-text">
                                Terms &amp; conditions apply as per payment
                                gateway service provider
                            </p>

                        </div>

                    </div>

                </div>

            </section>


            <Footer />

        </>
    );
}


export default RefundPolicy;